import { Grid, CircularProgress } from '@mui/material'
import Button from '@mui/material/Button'
import React, { Fragment } from 'react'

interface ConfirmActionProps {
  handleSubmitAction: any
  handleCloseModal: any
  confirmTitle: string
  confirmText: string
  negateText: string
  isLoading?: boolean
}

export const ConfirmAction: React.FC<ConfirmActionProps> = ({
  handleSubmitAction,
  handleCloseModal,
  confirmTitle,
  confirmText,
  negateText,
  isLoading
}) => {
  return (
    <Fragment>
      <Grid
        container
        spacing={4}
        direction='column'
        alignItems='center'
        justify='center'
      >
        <Grid item xs={12}>
          <h3>{confirmTitle}</h3>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Button
            variant='contained'
            color='primary'
            style={{ marginLeft: 16 }}
            onClick={handleSubmitAction}
            startIcon={
              isLoading ? <CircularProgress size='0.9rem' /> : undefined
            }
            disabled={isLoading}
          >
            {confirmText}
          </Button>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Button
            variant='contained'
            color='secondary'
            style={{ marginLeft: 16 }}
            onClick={handleCloseModal}
            disabled={isLoading}
          >
            {negateText}
          </Button>
        </Grid>
      </Grid>
    </Fragment>
  )
}
